import { render, staticRenderFns } from "./PaymentAttributeCreate.vue?vue&type=template&id=0de80e8c"
import script from "../../controllers/payment_attribute/payment-attribute-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_attribute/payment-attribute-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeCreate.vue?vue&type=style&index=0&id=0de80e8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports